import type { StyleLayer } from './utils/types'

export const layers_maxspeed_above40: StyleLayer[] = [
  {
    id: 'maxspeed-groessergleich40',
    type: 'line',
    filter: ['>=', ['get', 'maxspeed'], 40],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': [
        'interpolate',
        ['linear'],
        ['get', 'maxspeed'],
        40,
        '#eeb449',
        50,
        '#fc7c40',
        60,
        '#e92d07',
        80,
        '#b80505',
      ],
      'line-opacity': 0.98,
      'line-width': ['interpolate', ['linear'], ['zoom'], 11, 0.5, 15, 1],
    },
  },
  {
    id: 'hitarea-maxspeed40',
    type: 'line',
    filter: ['>=', ['get', 'maxspeed'], 40],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
]
